import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ListIcon16 = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M9.95254 6.33333H2.3335M13.0002 3H2.3335M8.3335 9.66667H2.3335M6.00016 13H2.3335'
    stroke='#3379BD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default ListIcon16;
